export default __webpack_public_path__ + "929247772e2e723072fc1d5801cb6d5e.svg";